<template>
  <OmtLayoutContainer>
    <OmtRow>
      <OmtTypography mb="16px" as="h1-bold" color="var(--colors-priary-gray)"> Protocolo de atendimento </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography as="p1" color="var(--colors-light-primary-gray)">
        Informe o protocolo da reclamação que você quer que seja reavaliada:
      </OmtTypography>
    </OmtRow>
    <OmtRow flex-direction="column" alignItems="center" justifyContent="center">
      <OmtInput
        type="number"
        variant="outline"
        class="token-input"
        placeholder="Insira o protocolo"
        v-model="protocol"
        inputmode="numeric"
      />
      <OmtButton
        v-if="showButtonValidar"
        mt="24px"
        variant="outline"
        height="40px"
        :w="['160px !important']"
        border="1px solid var(--colors-light-primary-navy-blue)"
        @click="validateProtocol"
      >
        <OmtTypography as="h3-bold" color="var(--colors-light-primary-navy-blue)">Validar protocolo</OmtTypography>
      </OmtButton>
    </OmtRow>
    <OmtRow mt="24px" v-if="searchProtocol.statusCode && !isOk">
      <SacCardInfo :title="titleStatus">
        <CFlex flexDirection="column">
          <CBox>
            <OmtTypography as="p1" color="var(--colors-light-primary-gray)">
              {{
                isPendency
                  ? "Aguarde a resposta da reclamação atual antes de solicitar reanálise pela Ouvidoria."
                  : isNotFound
                  ? "Confira o número e tente de novo, por favor."
                  : "Entre em contato com a Central de Atendimento, registre sua reclamação e aguarde a resposta"
              }}
            </OmtTypography>
          </CBox>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray)" v-if="isPendency">
            Previsão de resposta: {{ searchProtocol.responseAt }}.
          </OmtTypography>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray)" v-if="isNotComplaint">
            Caso ela não seja satisfatória, você pode solicitar a reanálise pela Ouvidoria.
          </OmtTypography>
        </CFlex>
      </SacCardInfo>
    </OmtRow>
    <OmtRow v-if="showButton" mt="48px" justifyContent="center">
      <OmtButton :w="['342px !important']" @click="actionButton">{{ labelButton }}</OmtButton>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import RequestCard from "@/components/Organisms/Requests/RequestCard.vue";
import FilterModal from "@/components/Organisms/Requests/FilterModal.vue";
import RequestListSortButton from "@/components/Organisms/Requests/RequestListSortButton.vue";
import AvaliationModal from "@/components/Organisms/AvaliationModal.vue";
import SacCardInfo from "@/components/Organisms/Sac/SacCardInfo.vue";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "ProtocolOuvidoria",
  components: {
    RequestCard,
    FilterModal,
    RequestListSortButton,
    AvaliationModal,
    SacCardInfo
  },
  data() {
    return {
      protocol: "",
      searchProtocol: {},
      showButtonValidar: true
    };
  },
  computed: {
    showButton() {
      return this.searchProtocol.statusCode;
    },
    labelButton() {
      if (this.isPendency) {
        return "Concluir";
      }
      if (this.isOk) {
        return "Continuar";
      }
      return "Ligar para a central";
    },
    isPendency() {
      return this.searchProtocol.statusCode === "A";
    },
    isNotFound() {
      return this.searchProtocol.statusCode === "N";
    },
    isOk() {
      return this.searchProtocol.statusCode === "V";
    },
    isNotComplaint() {
      return this.searchProtocol.statusCode === "I";
    },
    titleStatus() {
      if (this.isPendency) {
        return "Protocolo em análise";
      }
      if (this.isNotFound) {
        return "Protocolo não encontrado";
      }
      if (this.isNotComplaint) {
        return "O protocolo informado não é de uma reclamação respondida";
      }
      return "";
    }
  },
  watch: {
    protocol() {
      if (this.searchProtocol && this.searchProtocol.statusCode) {
        this.searchProtocol = {};
      }
      this.showButtonValidar = true;
    }
  },
  methods: {
    ...mapActions("sac", ["fetchProtocolReclamation"]),
    ...mapMutations("sac", ["SET_NEW_SOLICITATION", "CLEAN_NEW_SOLICITATION"]),
    async validateProtocol() {
      this.CLEAN_NEW_SOLICITATION();
      try {
        this.$root.$emit("show-loading");
        this.searchProtocol = await this.fetchProtocolReclamation({ protocol: this.protocol });

        if (this.searchProtocol.statusCode === "V") {
          this.showButtonValidar = false;
        }
      } catch (error) {
        this.searchProtocol = {};
      } finally {
        this.$root.$emit("hide-loading");
      }
    },
    cleanSortsAndFilters() {
      return;
    },
    callCentral() {
      window.open("tel:08007264000", "_self");
    },
    actionButton() {
      if (this.isOk) {
        this.SET_NEW_SOLICITATION({ protocolo: this.protocol });
        this.$router.push("/ouvidoria/criar/revisao");
      } else if (this.isPendency) {
        this.$router.push("/ouvidoria/");
      } else {
        this.callCentral();
      }
    }
  },
  async mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped>
::v-deep input {
  font-size: 22px;
  font-weight: 700;
  line-height: 33px;
  letter-spacing: 0em;
  text-align: center;
  letter-spacing: 2px;
}

::v-deep input::placeholder {
  color: var(--colors-light-secondary-divider);
}

@media (max-width: 992px) {
  ::v-deep input::placeholder {
    font-size: 20px;
  }
}
</style>
